import Colors from '@shared/assets/style/default/color';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListUpgradablePlanSeparator = styled.div<React.CSSProperties>`
  background: ${Colors['text']};
  height: ${150 * Screen.widthRatio}px;
  margin: 0 ${48 * Screen.widthRatio}px;
  width: ${3 * Screen.widthRatio}px;
`;

export default ChannelListUpgradablePlanSeparator;
